//libs
import React, { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import _debounce from 'lodash/debounce';

import { cn } from '@lyearn/style';
import { Input } from '@lyearn/ui';

//styles
import { inputStyles } from './styles';
//types
import { TextInputProps } from './types';

const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  const {
    value = '',
    onChange,
    onPressEnter,
    disabled,
    placeholder = '',
    variant = 'display-xxl',
    className,
    autoFocus,
    readOnly,
    color,
    maxRows,
  } = props;

  const [input, setInput] = useState(value as string);

  const debounceOnChange = useMemo(
    () => _debounce((text) => onChange?.(text || placeholder), 100),
    [onChange, placeholder],
  );

  const _onChange = useCallback(
    (event: any) => {
      setInput(event.target.value);
      debounceOnChange(event.target.value);
    },
    [debounceOnChange],
  );

  const _onKeyDown = useCallback(
    (event: any) => {
      if (event.key === 'Enter' && onPressEnter) {
        event.preventDefault();
        onPressEnter();
      }
    },
    [onPressEnter],
  );

  useEffect(() => {
    setInput(value);
  }, [setInput, value]);

  return (
    <Input
      multiline
      autoFocus={autoFocus}
      className={cn('w-full border-none', inputStyles, className)}
      color={color}
      data-id="description"
      disabled={disabled}
      inputRef={ref}
      maxRows={maxRows}
      placeholder={placeholder}
      readOnly={readOnly}
      value={input === placeholder ? '' : input}
      variant={variant}
      onChange={_onChange}
      onKeyDown={_onKeyDown}
    />
  );
});

export default React.memo(TextInput);
